
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexHpK7Fn7sxOMeta } from "/codebuild/output/src3655442736/src/pages/index.vue?macro=true";
import { default as aboutfOWwJHIrIzMeta } from "/codebuild/output/src3655442736/src/pages/about.vue?macro=true";
import { default as dataKL0wmUmOZ1Meta } from "/codebuild/output/src3655442736/src/pages/account-settings/data.vue?macro=true";
import { default as manage_45subscriptionkFafhcJIJqMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/manage-subscription.vue?macro=true";
import { default as positioningAN977vJjslMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/positioning.vue?macro=true";
import { default as privacyJaQadNMMSRMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/privacy.vue?macro=true";
import { default as remove_45account8Qsyx3jLTRMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/remove-account.vue?macro=true";
import { default as statueN1pzg3WevBMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/statue.vue?macro=true";
import { default as supportXWoKTPAYKfMeta } from "/codebuild/output/src3655442736/src/pages/account-settings/support.vue?macro=true";
import { default as account_45settingsstzaQkPeAsMeta } from "/codebuild/output/src3655442736/src/pages/account-settings.vue?macro=true";
import { default as activate_45accountzCRMEDTgvsMeta } from "/codebuild/output/src3655442736/src/pages/activate-account.vue?macro=true";
import { default as companybSbVNOOdFOMeta } from "/codebuild/output/src3655442736/src/pages/admin/company.vue?macro=true";
import { default as consentsEMcvs1HPsMMeta } from "/codebuild/output/src3655442736/src/pages/admin/consents.vue?macro=true";
import { default as leadsE6yZVfnp15Meta } from "/codebuild/output/src3655442736/src/pages/admin/leads.vue?macro=true";
import { default as paymentsVN02imsLCvMeta } from "/codebuild/output/src3655442736/src/pages/admin/payments.vue?macro=true";
import { default as premiumKcK8Qty3SSMeta } from "/codebuild/output/src3655442736/src/pages/admin/premium.vue?macro=true";
import { default as profilesu1LV6GlQYrMeta } from "/codebuild/output/src3655442736/src/pages/admin/profiles.vue?macro=true";
import { default as usersuLZ1Q4va6yMeta } from "/codebuild/output/src3655442736/src/pages/admin/users.vue?macro=true";
import { default as change_45passwordKPZraD1s9nMeta } from "/codebuild/output/src3655442736/src/pages/change-password.vue?macro=true";
import { default as _91id_93pdqF6NP2FuMeta } from "/codebuild/output/src3655442736/src/pages/chat/[id].vue?macro=true";
import { default as aiPMfQbQVJkRMeta } from "/codebuild/output/src3655442736/src/pages/chat/ai.vue?macro=true";
import { default as index2FFygVWAHCMeta } from "/codebuild/output/src3655442736/src/pages/chat/index.vue?macro=true";
import { default as chat6coslLRGRAMeta } from "/codebuild/output/src3655442736/src/pages/chat.vue?macro=true";
import { default as _91id_934Lvqf3JXMtMeta } from "/codebuild/output/src3655442736/src/pages/client/profile/[id].vue?macro=true";
import { default as indexXk1B8RnExjMeta } from "/codebuild/output/src3655442736/src/pages/client/profile/index.vue?macro=true";
import { default as _91id_93hgYQZKqSKcMeta } from "/codebuild/output/src3655442736/src/pages/contacts/[id].vue?macro=true";
import { default as indexJ9dRQKtoQ8Meta } from "/codebuild/output/src3655442736/src/pages/contacts/index.vue?macro=true";
import { default as contactsq5ySB0iq53Meta } from "/codebuild/output/src3655442736/src/pages/contacts.vue?macro=true";
import { default as _91userId_93qd7EA7ES3PMeta } from "/codebuild/output/src3655442736/src/pages/delete-mailing/[email]/[userId].vue?macro=true";
import { default as indexdtH279kAuMMeta } from "/codebuild/output/src3655442736/src/pages/login/index.vue?macro=true";
import { default as register_45success0fobBSlbLOMeta } from "/codebuild/output/src3655442736/src/pages/login/register-success.vue?macro=true";
import { default as logintWpa1091yZMeta } from "/codebuild/output/src3655442736/src/pages/login.vue?macro=true";
import { default as logoutfHDuDVvmVMMeta } from "/codebuild/output/src3655442736/src/pages/logout.vue?macro=true";
import { default as consentsBxJNTbws1OMeta } from "/codebuild/output/src3655442736/src/pages/manager/consents.vue?macro=true";
import { default as integrationsdO8Q8Twe0VMeta } from "/codebuild/output/src3655442736/src/pages/manager/integrations.vue?macro=true";
import { default as leadsvH9zzSfIWGMeta } from "/codebuild/output/src3655442736/src/pages/manager/leads.vue?macro=true";
import { default as paymentsE7M8ZUWwGDMeta } from "/codebuild/output/src3655442736/src/pages/manager/payments.vue?macro=true";
import { default as profilebKBh0MvauIMeta } from "/codebuild/output/src3655442736/src/pages/manager/profile.vue?macro=true";
import { default as team7fAGQcn3vdMeta } from "/codebuild/output/src3655442736/src/pages/manager/team.vue?macro=true";
import { default as indexJS26wr8fvzMeta } from "/codebuild/output/src3655442736/src/pages/marketplace/index.vue?macro=true";
import { default as _91catId_93_46clientseLUCkHyFEMeta } from "/codebuild/output/src3655442736/src/pages/marketplace/search/[catId].client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/codebuild/output/src3655442736/src/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as marketplaceXfQroiXgn1Meta } from "/codebuild/output/src3655442736/src/pages/marketplace.vue?macro=true";
import { default as subscribeDdEjSLV2zFMeta } from "/codebuild/output/src3655442736/src/pages/newsletter/subscribe.vue?macro=true";
import { default as find_46client5nUqrVX7vbMeta } from "/codebuild/output/src3655442736/src/pages/orders/find.client.vue?macro=true";
import { default as my_46clientfBseCfpaWbMeta } from "/codebuild/output/src3655442736/src/pages/orders/my.client.vue?macro=true";
import { default as privacyq1B0907QXDMeta } from "/codebuild/output/src3655442736/src/pages/privacy.vue?macro=true";
import { default as indexmxsYadgsh7Meta } from "/codebuild/output/src3655442736/src/pages/recover/index.vue?macro=true";
import { default as successT7OVcbR4lJMeta } from "/codebuild/output/src3655442736/src/pages/register/success.vue?macro=true";
import { default as _91id_93zJ2SMFqDPDMeta } from "/codebuild/output/src3655442736/src/pages/sales/profile/[id].vue?macro=true";
import { default as index6GbIvbCuV6Meta } from "/codebuild/output/src3655442736/src/pages/sales/profile/index.vue?macro=true";
import { default as statue4eNAk45fYvMeta } from "/codebuild/output/src3655442736/src/pages/statue.vue?macro=true";
import { default as successujGuIUhUPTMeta } from "/codebuild/output/src3655442736/src/pages/subscription/success.vue?macro=true";
import { default as component_45stubWbaZ6PLC43Meta } from "/codebuild/output/src3655442736/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubWbaZ6PLC43 } from "/codebuild/output/src3655442736/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexHpK7Fn7sxOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutfOWwJHIrIzMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/about.vue")
  },
  {
    name: "about___pl",
    path: "/pl/about",
    meta: aboutfOWwJHIrIzMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/about.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account-settings",
    meta: account_45settingsstzaQkPeAsMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___en",
    path: "data",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___en",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___en",
    path: "positioning",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___en",
    path: "privacy",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___en",
    path: "remove-account",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___en",
    path: "statue",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___en",
    path: "support",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "account-settings___pl",
    path: "/pl/account-settings",
    meta: account_45settingsstzaQkPeAsMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings.vue"),
    children: [
  {
    name: "account-settings-data___pl",
    path: "data",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/data.vue")
  },
  {
    name: "account-settings-manage-subscription___pl",
    path: "manage-subscription",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/manage-subscription.vue")
  },
  {
    name: "account-settings-positioning___pl",
    path: "positioning",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/positioning.vue")
  },
  {
    name: "account-settings-privacy___pl",
    path: "privacy",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/privacy.vue")
  },
  {
    name: "account-settings-remove-account___pl",
    path: "remove-account",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/remove-account.vue")
  },
  {
    name: "account-settings-statue___pl",
    path: "statue",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/statue.vue")
  },
  {
    name: "account-settings-support___pl",
    path: "support",
    component: () => import("/codebuild/output/src3655442736/src/pages/account-settings/support.vue")
  }
]
  },
  {
    name: "activate-account___en",
    path: "/en/activate-account",
    meta: activate_45accountzCRMEDTgvsMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/activate-account.vue")
  },
  {
    name: "activate-account___pl",
    path: "/pl/activate-account",
    meta: activate_45accountzCRMEDTgvsMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/activate-account.vue")
  },
  {
    name: "admin-company___en",
    path: "/en/admin/company",
    meta: companybSbVNOOdFOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/company.vue")
  },
  {
    name: "admin-company___pl",
    path: "/pl/admin/company",
    meta: companybSbVNOOdFOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/company.vue")
  },
  {
    name: "admin-consents___en",
    path: "/en/admin/consents",
    meta: consentsEMcvs1HPsMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/consents.vue")
  },
  {
    name: "admin-consents___pl",
    path: "/pl/admin/consents",
    meta: consentsEMcvs1HPsMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/consents.vue")
  },
  {
    name: "admin-leads___en",
    path: "/en/admin/leads",
    meta: leadsE6yZVfnp15Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/leads.vue")
  },
  {
    name: "admin-leads___pl",
    path: "/pl/admin/leads",
    meta: leadsE6yZVfnp15Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/leads.vue")
  },
  {
    name: "admin-payments___en",
    path: "/en/admin/payments",
    meta: paymentsVN02imsLCvMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/payments.vue")
  },
  {
    name: "admin-payments___pl",
    path: "/pl/admin/payments",
    meta: paymentsVN02imsLCvMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/payments.vue")
  },
  {
    name: "admin-premium___en",
    path: "/en/admin/premium",
    meta: premiumKcK8Qty3SSMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/premium.vue")
  },
  {
    name: "admin-premium___pl",
    path: "/pl/admin/premium",
    meta: premiumKcK8Qty3SSMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/premium.vue")
  },
  {
    name: "admin-profiles___en",
    path: "/en/admin/profiles",
    meta: profilesu1LV6GlQYrMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-profiles___pl",
    path: "/pl/admin/profiles",
    meta: profilesu1LV6GlQYrMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/profiles.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: usersuLZ1Q4va6yMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/users.vue")
  },
  {
    name: "admin-users___pl",
    path: "/pl/admin/users",
    meta: usersuLZ1Q4va6yMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/admin/users.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: change_45passwordKPZraD1s9nMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/change-password.vue")
  },
  {
    name: "change-password___pl",
    path: "/pl/change-password",
    meta: change_45passwordKPZraD1s9nMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/change-password.vue")
  },
  {
    name: chat6coslLRGRAMeta?.name,
    path: "/en/chat",
    meta: chat6coslLRGRAMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___en",
    path: ":id()",
    meta: _91id_93pdqF6NP2FuMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___en",
    path: "ai",
    meta: aiPMfQbQVJkRMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/ai.vue")
  },
  {
    name: "chat___en",
    path: "",
    meta: index2FFygVWAHCMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/index.vue")
  }
]
  },
  {
    name: chat6coslLRGRAMeta?.name,
    path: "/pl/chat",
    meta: chat6coslLRGRAMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat.vue"),
    children: [
  {
    name: "chat-id___pl",
    path: ":id()",
    meta: _91id_93pdqF6NP2FuMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/[id].vue")
  },
  {
    name: "chat-ai___pl",
    path: "ai",
    meta: aiPMfQbQVJkRMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/ai.vue")
  },
  {
    name: "chat___pl",
    path: "",
    meta: index2FFygVWAHCMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/chat/index.vue")
  }
]
  },
  {
    name: "client-profile-id___en",
    path: "/en/client/profile/:id()",
    meta: _91id_934Lvqf3JXMtMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile-id___pl",
    path: "/pl/client/profile/:id()",
    meta: _91id_934Lvqf3JXMtMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/client/profile/[id].vue")
  },
  {
    name: "client-profile___en",
    path: "/en/client/profile",
    meta: indexXk1B8RnExjMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/client/profile/index.vue")
  },
  {
    name: "client-profile___pl",
    path: "/pl/client/profile",
    meta: indexXk1B8RnExjMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/client/profile/index.vue")
  },
  {
    name: contactsq5ySB0iq53Meta?.name,
    path: "/en/contacts",
    meta: contactsq5ySB0iq53Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___en",
    path: ":id()",
    meta: _91id_93hgYQZKqSKcMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___en",
    path: "",
    meta: indexJ9dRQKtoQ8Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: contactsq5ySB0iq53Meta?.name,
    path: "/pl/contacts",
    meta: contactsq5ySB0iq53Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts.vue"),
    children: [
  {
    name: "contacts-id___pl",
    path: ":id()",
    meta: _91id_93hgYQZKqSKcMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts/[id].vue")
  },
  {
    name: "contacts___pl",
    path: "",
    meta: indexJ9dRQKtoQ8Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/contacts/index.vue")
  }
]
  },
  {
    name: "delete-mailing-email-userId___en",
    path: "/en/delete-mailing/:email()/:userId()",
    meta: _91userId_93qd7EA7ES3PMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "delete-mailing-email-userId___pl",
    path: "/pl/delete-mailing/:email()/:userId()",
    meta: _91userId_93qd7EA7ES3PMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/delete-mailing/[email]/[userId].vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexHpK7Fn7sxOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    meta: indexHpK7Fn7sxOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/index.vue")
  },
  {
    name: logintWpa1091yZMeta?.name,
    path: "/en/login",
    component: () => import("/codebuild/output/src3655442736/src/pages/login.vue"),
    children: [
  {
    name: "login___en",
    path: "",
    meta: indexdtH279kAuMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___en",
    path: "register-success",
    meta: register_45success0fobBSlbLOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: logintWpa1091yZMeta?.name,
    path: "/pl/login",
    component: () => import("/codebuild/output/src3655442736/src/pages/login.vue"),
    children: [
  {
    name: "login___pl",
    path: "",
    meta: indexdtH279kAuMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/login/index.vue")
  },
  {
    name: "login-register-success___pl",
    path: "register-success",
    meta: register_45success0fobBSlbLOMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/login/register-success.vue")
  }
]
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutfHDuDVvmVMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/logout.vue")
  },
  {
    name: "logout___pl",
    path: "/pl/logout",
    meta: logoutfHDuDVvmVMMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/logout.vue")
  },
  {
    name: "manager-consents___en",
    path: "/en/manager/consents",
    meta: consentsBxJNTbws1OMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/consents.vue")
  },
  {
    name: "manager-consents___pl",
    path: "/pl/manager/consents",
    meta: consentsBxJNTbws1OMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/consents.vue")
  },
  {
    name: "manager-integrations___en",
    path: "/en/manager/integrations",
    meta: integrationsdO8Q8Twe0VMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-integrations___pl",
    path: "/pl/manager/integrations",
    meta: integrationsdO8Q8Twe0VMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/integrations.vue")
  },
  {
    name: "manager-leads___en",
    path: "/en/manager/leads",
    meta: leadsvH9zzSfIWGMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/leads.vue")
  },
  {
    name: "manager-leads___pl",
    path: "/pl/manager/leads",
    meta: leadsvH9zzSfIWGMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/leads.vue")
  },
  {
    name: "manager-payments___en",
    path: "/en/manager/payments",
    meta: paymentsE7M8ZUWwGDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/payments.vue")
  },
  {
    name: "manager-payments___pl",
    path: "/pl/manager/payments",
    meta: paymentsE7M8ZUWwGDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/payments.vue")
  },
  {
    name: "manager-profile___en",
    path: "/en/manager/profile",
    meta: profilebKBh0MvauIMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/profile.vue")
  },
  {
    name: "manager-profile___pl",
    path: "/pl/manager/profile",
    meta: profilebKBh0MvauIMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/profile.vue")
  },
  {
    name: "manager-team___en",
    path: "/en/manager/team",
    meta: team7fAGQcn3vdMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/team.vue")
  },
  {
    name: "manager-team___pl",
    path: "/pl/manager/team",
    meta: team7fAGQcn3vdMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/manager/team.vue")
  },
  {
    name: marketplaceXfQroiXgn1Meta?.name,
    path: "/en/marketplace",
    meta: marketplaceXfQroiXgn1Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___en",
    path: "",
    component: () => import("/codebuild/output/src3655442736/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___en",
    path: "search/:catId()",
    meta: _91catId_93_46clientseLUCkHyFEMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: marketplaceXfQroiXgn1Meta?.name,
    path: "/pl/marketplace",
    meta: marketplaceXfQroiXgn1Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/marketplace.vue"),
    children: [
  {
    name: "marketplace___pl",
    path: "",
    component: () => import("/codebuild/output/src3655442736/src/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-search-catId___pl",
    path: "search/:catId()",
    meta: _91catId_93_46clientseLUCkHyFEMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/marketplace/search/[catId].client.vue"))
  }
]
  },
  {
    name: "newsletter-subscribe___en",
    path: "/en/newsletter/subscribe",
    meta: subscribeDdEjSLV2zFMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "newsletter-subscribe___pl",
    path: "/pl/newsletter/subscribe",
    meta: subscribeDdEjSLV2zFMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/newsletter/subscribe.vue")
  },
  {
    name: "orders-find___en",
    path: "/en/orders/find",
    meta: find_46client5nUqrVX7vbMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-find___pl",
    path: "/pl/orders/find",
    meta: find_46client5nUqrVX7vbMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/orders/find.client.vue"))
  },
  {
    name: "orders-my___en",
    path: "/en/orders/my",
    meta: my_46clientfBseCfpaWbMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/orders/my.client.vue"))
  },
  {
    name: "orders-my___pl",
    path: "/pl/orders/my",
    meta: my_46clientfBseCfpaWbMeta || {},
    component: () => createClientPage(() => import("/codebuild/output/src3655442736/src/pages/orders/my.client.vue"))
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacyq1B0907QXDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/privacy.vue")
  },
  {
    name: "privacy___pl",
    path: "/pl/privacy",
    meta: privacyq1B0907QXDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/privacy.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: indexmxsYadgsh7Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/recover/index.vue")
  },
  {
    name: "recover___pl",
    path: "/pl/recover",
    meta: indexmxsYadgsh7Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/recover/index.vue")
  },
  {
    name: "register-success___en",
    path: "/en/register/success",
    component: () => import("/codebuild/output/src3655442736/src/pages/register/success.vue")
  },
  {
    name: "register-success___pl",
    path: "/pl/register/success",
    component: () => import("/codebuild/output/src3655442736/src/pages/register/success.vue")
  },
  {
    name: "sales-profile-id___en",
    path: "/en/sales/profile/:id()",
    meta: _91id_93zJ2SMFqDPDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile-id___pl",
    path: "/pl/sales/profile/:id()",
    meta: _91id_93zJ2SMFqDPDMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/sales/profile/[id].vue")
  },
  {
    name: "sales-profile___en",
    path: "/en/sales/profile",
    meta: index6GbIvbCuV6Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/sales/profile/index.vue")
  },
  {
    name: "sales-profile___pl",
    path: "/pl/sales/profile",
    meta: index6GbIvbCuV6Meta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/sales/profile/index.vue")
  },
  {
    name: "statue___en",
    path: "/en/statue",
    meta: statue4eNAk45fYvMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/statue.vue")
  },
  {
    name: "statue___pl",
    path: "/pl/statue",
    meta: statue4eNAk45fYvMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/statue.vue")
  },
  {
    name: "subscription-success___en",
    path: "/en/subscription/success",
    meta: successujGuIUhUPTMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/subscription/success.vue")
  },
  {
    name: "subscription-success___pl",
    path: "/pl/subscription/success",
    meta: successujGuIUhUPTMeta || {},
    component: () => import("/codebuild/output/src3655442736/src/pages/subscription/success.vue")
  },
  {
    name: component_45stubWbaZ6PLC43Meta?.name,
    path: "/old-page",
    component: component_45stubWbaZ6PLC43
  }
]